module.exports = __webpack_public_path__ + "static/tablet-f6d3f97f569d1cc2f651387581629630.png";